var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('company-table', {
    attrs: {
      "partnerId": _vm.partnerId,
      "showSelect": true,
      "singleSelect": true,
      "showSideCard": false,
      "selectedItems": _vm.selected,
      "filters": _vm.filters
    },
    on: {
      "update:selectedItems": function updateSelectedItems($event) {
        _vm.selected = $event;
      },
      "update:selected-items": function updateSelectedItems($event) {
        _vm.selected = $event;
      },
      "click:row": function clickRow($event) {
        _vm.selected = [$event];
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }